package com.neurobs.ccabserver.administrator.contexts

import com.neurobs.react.ContextBase

/** Provides the URLs for resources linked from HTML */
class ResourceURLContext(map: Map[ResourceURLContext.Resource.Value, String]) {
	import ResourceURLContext._

	def get(t: Resource.Value): String = {
		map(t)
	}

	if (Resource.values.exists(!map.contains(_))) {
//		throw new RuntimeException("ResourceURLContext is missing resources")
	}
}

object ResourceURLContext extends ContextBase[ResourceURLContext] {
	override protected def defaultStateValue() = new ResourceURLContext(Map())

	object Resource extends Enumeration {
		val HorizontalLogo = Value("HorizontalLogo")
		val CircleLogoWithText = Value("CircleLogoWithText")
	}
}